import { FC, useCallback } from "react";
import { CodeExtension } from "@remirror/extension-code";
import { useActive, useCommands } from "@remirror/react";
import { CommandButton, CommandButtonProps } from "@remirror/react-ui";

export interface ToggleCodeButtonProps
  extends Omit<
    CommandButtonProps,
    "commandName" | "active" | "enabled" | "attrs" | "onSelect"
  > {
  onBlur: () => void;
}

export const ToggleCodeButton: FC<ToggleCodeButtonProps> = (props) => {
  const { toggleCode } = useCommands<CodeExtension>();

  const handleSelect = useCallback(() => {
    if (toggleCode.enabled()) {
      toggleCode();
      props.onBlur();
    }
  }, [props, toggleCode]);

  const active = useActive<CodeExtension>().code();
  const enabled = toggleCode.enabled();

  return (
    <CommandButton
      {...props}
      commandName="toggleCode"
      active={active}
      enabled={enabled}
      onSelect={handleSelect}
    />
  );
};
